import { Button, Typography } from '@mui/material'
import { FC } from 'react'

export interface BarButtonProps {
  id: string
  startIcon: any
  onClick: () => void
  bgColor?: string
  title: string
  refr?: any
}

export const BarButton: FC<BarButtonProps> = ({
  id,
  startIcon,
  onClick,
  bgColor,
  title,
  refr,
}) => {
  return (
    <div
      style={{
        borderColor: bgColor,
        borderWidth: 2,
        borderStyle: 'solid',
        height: 30,
        borderRadius: 15,
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <Button
        id={id}
        data-cy={`id_button_${id}`}
        sx={{ color: bgColor, height: 30, pl:1, pr:1.2}}
        startIcon={startIcon}
        onClick={() => {
          onClick()
        }}
        
        ref={refr}
      >
       <Typography noWrap={true} sx={{fontSize:'13px'}}> {title} </Typography>
      </Button>
    </div>
  )
}
